export const OFFER_MP_STATUS = {
  active: { label: 'Active', color: 'green' },
  inactive: { label: 'Inactive', color: 'red' },
};

export const OFFER_PUBLISH_STATUS = {
  ignore: { label: 'Ne pas publier', color: 'red' },
  to_publish: { label: 'À publier', color: 'gold' },
  published: { label: 'Publié', color: 'green' },
};

export const OFFER_PUBLICATION_STATE = {
  up_to_date: { label: 'À jour', color: 'green' },
  pending: { label: 'En attente', color: 'gold' },
  ignored: { label: 'Ignorée', color: 'orange' },
  error: { label: 'Erreur', color: 'red' },
};

const options = (statuses) =>
  Object.entries(statuses).map(([value, { label }]) => ({ value, label }));

export const OFFER_MP_STATUS_OPTIONS = options(OFFER_MP_STATUS);
export const OFFER_PUBLISH_STATUS_OPTIONS = options(OFFER_PUBLISH_STATUS);
export const OFFER_PUBLICATION_STATE_OPTIONS = options(OFFER_PUBLICATION_STATE);

export const OFFER_UPDATE_MAX_OFFER_IDS = 5000;

export const OFFER_EXPORT_MAX_ROWS = 5000;

export const OFFER_UPDATE_SCOPE = {
  PRICE: 'price',
  STOCK: 'stock',
  PRICE_STOCK: 'price_stock',
};

export const buildOfferUpdateScope = (fields = []) => {
  const hasPrice = fields.includes('price');
  const hasStock = fields.includes('stock');

  if (hasPrice && hasStock) return OFFER_UPDATE_SCOPE.PRICE_STOCK;
  if (hasPrice) return OFFER_UPDATE_SCOPE.PRICE;
  if (hasStock) return OFFER_UPDATE_SCOPE.STOCK;
  return null;
};

// Channels dont le « pays » est une enseigne (channel 014 de Leroy Merlin FR).
export const OFFER_CHANNEL_COUNTRY_LABELS = {
  BM: 'Bricoman',
};

// Pays vendus seulement par un channel, sans store à eux (Allegro CZ, SK, HU
// sur l'offre du store Allegro PL) : ajoutés au filtre pays.
export const OFFER_CHANNEL_ONLY_COUNTRIES = ['CZ', 'HU', 'SK'];

// État de publication d'un pays, renvoyé par la marketplace (Allegro).
export const OFFER_CHANNEL_PUBLICATION_STATE = {
  PENDING: { label: 'En attente', color: 'gold' },
  APPROVED: { label: 'Publiée', color: 'green' },
  REFUSED: { label: 'Refusée', color: 'red' },
};

export const OFFER_EXPORT_FORMATS = [
  { key: 'xlsx', label: 'Excel (.xlsx)' },
  { key: 'csv', label: 'CSV (.csv)' },
];
